import { SERVER_URL } from "../utils/constants";

const changeUserActiveStatus = async (user) => {
  const response = await fetch(`${SERVER_URL}/changeUserActiveStatus`, {
    method: "post",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify({ user }),
  });
  if (response.status === 400) {
    const { errors } = await response.json();
    return { errors };
  }
  return await response.json();
};

export default changeUserActiveStatus;
